import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 23px;
  height: 20px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "20",
  "aria-label": "Inloggen"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-7.000000, -7.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "0",
  y: "0",
  width: "24",
  height: "24"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#FFFFFF",
  strokeWidth: "3",
  cx: "12.4394433",
  cy: "8.10787506",
  r: "4.60787506"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.8788866,21.9894093 C21.8788866,17.0828111 17.6527039,13.1052274 12.4394433,13.1052274 C7.22618271,13.1052274 3,17.0828111 3,21.9894093",
  stroke: "#FFFFFF",
  strokeWidth: "3"
}))))));